export const TRANSLATIONS_PROSPECTS = {
  title: 'prospects.title',
  emptyState: {
    title: 'prospects.empty_state.title',
    description: 'prospects.empty_state.description',
    newProspect: 'prospects.empty_state.new_prospect',
    filterTitle: 'prospects.empty_state.filter_title',
    filterDescription: 'prospects.empty_state.filter_description'
  },
  prospectsList: {
    searchPlaceholder: 'prospects.list.search_placeholder',
    workforceSize: 'prospects.list.workforce_size'
  },
  detail: {
    viewFullProfile: 'prospects.detail.view_full_profile',
    selectProspect: 'prospects.detail.select_prospect',
    pendingQuote: {
      nudgeTitle: 'prospects.detail.pending_quote.nudge_title',
      nudgeBody: 'prospects.detail.pending_quote.nudge_body',
      createFirstQuote: 'prospects.detail.pending_quote.create_first_quote',
      doItLater: 'prospects.detail.pending_quote.do_it_later',
      noQuotesHint: 'prospects.detail.pending_quote.no_quotes_hint',
      getQuote: 'prospects.detail.pending_quote.get_quote'
    },
    quoted: {
      sectionLabel: 'prospects.detail.quoted.section_label',
      acceptedSectionLabel: 'prospects.detail.quoted.accepted_section_label',
      unselectedSectionLabel: 'prospects.detail.quoted.unselected_section_label',
      newQuote: 'prospects.detail.quoted.new_quote',
      moveToActivation: 'prospects.detail.quoted.move_to_activation',
      acceptedQuotes: 'prospects.detail.quoted.accepted_quotes',
      acceptTooltip: 'prospects.detail.quoted.accept_tooltip',
      activationRequestedToast: 'prospects.detail.quoted.activation_requested_toast',
      activationMissingInfo: {
        title: 'prospects.detail.quoted.activation_missing_info.title',
        subtitle: 'prospects.detail.quoted.activation_missing_info.subtitle',
        clientInfo: {
          sectionTitle: 'prospects.detail.quoted.activation_missing_info.client_info.section_title'
        },
        saveAsPending: 'prospects.detail.quoted.activation_missing_info.save_as_pending',
        completeNow: 'prospects.detail.quoted.activation_missing_info.complete_now'
      }
    },
    pendingActivation: {
      acceptedQuotes: 'prospects.detail.pending_activation.accepted_quotes',
      otherQuotes: 'prospects.detail.pending_activation.other_quotes',
      completeActivation: 'prospects.detail.pending_activation.complete_activation',
      activate: 'prospects.detail.pending_activation.activate',
      readyTitle: 'prospects.detail.pending_activation.ready_title',
      readyBody: 'prospects.detail.pending_activation.ready_body',
      checklistTitle: 'prospects.detail.pending_activation.checklist_title',
      checklistCompleted: 'prospects.detail.pending_activation.checklist_completed',
      checklistItemsLeft: 'prospects.detail.pending_activation.checklist_items_left',
      activationRequestedTitle: 'prospects.detail.pending_activation.activation_requested_title',
      activationRequestedDescription: 'prospects.detail.pending_activation.activation_requested_description',
      checks: {
        census: 'prospects.detail.pending_activation.checks.census',
        payroll: 'prospects.detail.pending_activation.checks.payroll'
      }
    },
    actions: {
      markAsLost: 'prospects.detail.actions.mark_as_lost',
      markAsInactive: 'prospects.detail.actions.mark_as_inactive'
    },
    quotationCard: {
      downloadPdf: 'prospects.detail.quotation_card.download_pdf',
      downloadPdfError: 'prospects.detail.quotation_card.download_pdf_error',
      edit: 'prospects.detail.quotation_card.edit',
      acceptQuote: 'prospects.detail.quotation_card.accept_quote',
      clientAccepted: 'prospects.detail.quotation_card.client_accepted',
      quoteAcceptedToast: 'prospects.detail.quotation_card.quote_accepted_toast',
      unacceptQuoteModal: {
        title: 'prospects.detail.quotation_card.unaccept_quote_modal.title',
        bodyWarning: 'prospects.detail.quotation_card.unaccept_quote_modal.body_warning',
        bodyConsequence: 'prospects.detail.quotation_card.unaccept_quote_modal.body_consequence',
        cancel: 'prospects.detail.quotation_card.unaccept_quote_modal.cancel',
        confirm: 'prospects.detail.quotation_card.unaccept_quote_modal.confirm'
      }
    }
  },
  newProspect: 'prospects.new_prospect',
  status: {
    pending_quote: 'prospects.status.pending_quote',
    quoted: 'prospects.status.quoted',
    pending_activation: 'prospects.status.pending_activation',
    lost: 'prospects.status.lost',
    inactive: 'prospects.status.inactive',
    unknown: 'prospects.status.unknown'
  },
  forms: {
    companyName: {
      label: 'prospects.forms.company_name.label',
      placeholder: 'prospects.forms.company_name.placeholder'
    },
    salesModel: {
      label: 'prospects.forms.sales_model.label',
      appAndInsurance: {
        title: 'prospects.forms.sales_model.app_and_insurance.title',
        description: 'prospects.forms.sales_model.app_and_insurance.description'
      },
      appOnly: {
        title: 'prospects.forms.sales_model.app_only.title',
        description: 'prospects.forms.sales_model.app_only.description'
      }
    },
    workforceSize: {
      label: 'prospects.forms.workforce_size.label',
      placeholder: 'prospects.forms.workforce_size.placeholder',
      note: 'prospects.forms.workforce_size.note'
    },
    documentValue: {
      label: 'prospects.forms.document_value.label'
    },
    industry: {
      label: 'prospects.forms.industry.label',
      placeholder: 'prospects.forms.industry.placeholder'
    },
    street: {
      label: 'prospects.forms.street.label',
      placeholder: 'prospects.forms.street.placeholder'
    },
    addressLine1: {
      label: 'prospects.forms.address_line_1.label',
      placeholder: 'prospects.forms.address_line_1.placeholder'
    },
    city: {
      label: 'prospects.forms.city.label',
      placeholder: 'prospects.forms.city.placeholder'
    },
    state: {
      label: 'prospects.forms.state.label',
      placeholder: 'prospects.forms.state.placeholder'
    },
    zipCode: {
      label: 'prospects.forms.zip_code.label',
      placeholder: 'prospects.forms.zip_code.placeholder'
    },
    contactName: {
      placeholder: 'prospects.forms.contact_name.placeholder'
    },
    contactEmail: {
      placeholder: 'prospects.forms.contact_email.placeholder'
    },
    contactPhone: {
      placeholder: 'prospects.forms.contact_phone.placeholder'
    },
    contactTitle: {
      placeholder: 'prospects.forms.contact_title.placeholder'
    },
    billingName: {
      placeholder: 'prospects.forms.billing_name.placeholder'
    },
    billingEmail: {
      placeholder: 'prospects.forms.billing_email.placeholder'
    }
  },
  newProspectModal: {
    title: 'prospects.new_prospect_modal.title',
    additionalInformation: 'prospects.new_prospect_modal.additional_information',
    sections: {
      primaryContact: 'prospects.new_prospect_modal.sections.primary_contact',
      billingContact: 'prospects.new_prospect_modal.sections.billing_contact'
    },
    billing: {
      sameAsPrimary: 'prospects.new_prospect_modal.billing.same_as_primary',
      differentPerson: 'prospects.new_prospect_modal.billing.different_person'
    },
    buttons: {
      create: 'prospects.new_prospect_modal.buttons.create'
    },
    toast: {
      error: 'prospects.new_prospect_modal.toast.error'
    }
  },
  profile: {
    empty: 'prospects.profile.empty',
    back: 'prospects.profile.back',
    notFound: 'prospects.profile.not_found',
    saveError: 'prospects.profile.save_error',
    fields: {
      legalName: 'prospects.profile.fields.legal_name',
      employees: 'prospects.profile.fields.employees',
      taxId: 'prospects.profile.fields.tax_id',
      address: 'prospects.profile.fields.address',
      industry: 'prospects.profile.fields.industry',
      title: 'prospects.profile.fields.title',
      whatYouOffer: 'prospects.profile.fields.what_you_offer'
    },
    headcountMinimum: 'prospects.profile.headcount_minimum',
    headcountRequired: 'prospects.profile.headcount_required',
    tooltips: {
      headcountMinimum: 'prospects.profile.tooltips.headcount_minimum'
    },
    salesModel: {
      discardNote: 'prospects.profile.sales_model.discard_note'
    },
    discardQuotes: {
      title: 'prospects.profile.discard_quotes.title',
      body: 'prospects.profile.discard_quotes.body',
      keep: 'prospects.profile.discard_quotes.keep',
      confirm: 'prospects.profile.discard_quotes.confirm'
    },
    company: {
      title: 'prospects.profile.company.title'
    },
    primaryContact: {
      title: 'prospects.profile.primary_contact.title',
      empty: 'prospects.profile.primary_contact.empty'
    },
    billingContact: {
      title: 'prospects.profile.billing_contact.title',
      empty: 'prospects.profile.billing_contact.empty'
    },
    activation: {
      title: 'prospects.profile.activation.title',
      clientData: 'prospects.profile.activation.client_data',
      pendingInfo: 'prospects.profile.activation.pending_info',
      complete: 'prospects.profile.activation.complete',
      hint: 'prospects.profile.activation.hint',
      required: 'prospects.profile.activation.required',
      warningTitle: 'prospects.profile.activation.warning_title',
      warningBody: 'prospects.profile.activation.warning_body',
      checks: {
        taxId: 'prospects.profile.activation.checks.tax_id',
        industry: 'prospects.profile.activation.checks.industry',
        businessAddress: 'prospects.profile.activation.checks.business_address',
        primaryContactName: 'prospects.profile.activation.checks.primary_contact_name',
        primaryContactTitle: 'prospects.profile.activation.checks.primary_contact_title',
        primaryContactEmail: 'prospects.profile.activation.checks.primary_contact_email',
        primaryContactPhone: 'prospects.profile.activation.checks.primary_contact_phone',
        billingContactName: 'prospects.profile.activation.checks.billing_contact_name',
        billingContactTitle: 'prospects.profile.activation.checks.billing_contact_title',
        billingContactEmail: 'prospects.profile.activation.checks.billing_contact_email',
        billingContactPhone: 'prospects.profile.activation.checks.billing_contact_phone'
      }
    },
    activationSetup: {
      title: 'prospects.profile.activation_setup.title',
      badgePending: 'prospects.profile.activation_setup.badge_pending',
      badgeComplete: 'prospects.profile.activation_setup.badge_complete',
      census: {
        title: 'prospects.profile.activation_setup.census.title',
        intro: 'prospects.profile.activation_setup.census.intro',
        downloadTemplate: 'prospects.profile.activation_setup.census.download_template',
        upload: 'prospects.profile.activation_setup.census.upload',
        loaded: 'prospects.profile.activation_setup.census.loaded',
        remove: 'prospects.profile.activation_setup.census.remove',
        background: {
          runningTitle: 'prospects.profile.activation_setup.census.background.running_title',
          runningBody: 'prospects.profile.activation_setup.census.background.running_body',
          runningCta: 'prospects.profile.activation_setup.census.background.running_cta',
          successTitle: 'prospects.profile.activation_setup.census.background.success_title',
          successBody: 'prospects.profile.activation_setup.census.background.success_body',
          successCta: 'prospects.profile.activation_setup.census.background.success_cta',
          issuesTitle: 'prospects.profile.activation_setup.census.background.issues_title',
          issuesBody: 'prospects.profile.activation_setup.census.background.issues_body',
          issuesCta: 'prospects.profile.activation_setup.census.background.issues_cta',
          priceTitle: 'prospects.profile.activation_setup.census.background.price_title',
          priceBody: 'prospects.profile.activation_setup.census.background.price_body',
          priceCta: 'prospects.profile.activation_setup.census.background.price_cta'
        }
      },
      payroll: {
        title: 'prospects.profile.activation_setup.payroll.title',
        intro: 'prospects.profile.activation_setup.payroll.intro',
        frequencyLabel: 'prospects.profile.activation_setup.payroll.frequency_label',
        frequencyPlaceholder: 'prospects.profile.activation_setup.payroll.frequency_placeholder',
        lastPaymentLabel: 'prospects.profile.activation_setup.payroll.last_payment_label',
        save: 'prospects.profile.activation_setup.payroll.save',
        cancel: 'prospects.profile.activation_setup.payroll.cancel',
        unsavedChanges: 'prospects.profile.activation_setup.payroll.unsaved_changes',
        saved: 'prospects.profile.activation_setup.payroll.saved',
        frequency: {
          weekly: 'prospects.profile.activation_setup.payroll.frequency.weekly',
          biweekly: 'prospects.profile.activation_setup.payroll.frequency.biweekly',
          semiMonthly: 'prospects.profile.activation_setup.payroll.frequency.semi_monthly',
          monthly: 'prospects.profile.activation_setup.payroll.frequency.monthly'
        }
      },
      censusModal: {
        uploadTitle: 'prospects.profile.activation_setup.census_modal.upload_title',
        instruction1Title: 'prospects.profile.activation_setup.census_modal.instruction1_title',
        instruction2Title: 'prospects.profile.activation_setup.census_modal.instruction2_title',
        instruction3Title: 'prospects.profile.activation_setup.census_modal.instruction3_title',
        instruction3Sub: 'prospects.profile.activation_setup.census_modal.instruction3_sub',
        instruction4Title: 'prospects.profile.activation_setup.census_modal.instruction4_title',
        instruction4Sub: 'prospects.profile.activation_setup.census_modal.instruction4_sub',
        validatingTitle: 'prospects.profile.activation_setup.census_modal.validating_title',
        validatingHint: 'prospects.profile.activation_setup.census_modal.validating_hint',
        processingTitle: 'prospects.profile.activation_setup.census_modal.processing_title',
        processingHint: 'prospects.profile.activation_setup.census_modal.processing_hint',
        successTitle: 'prospects.profile.activation_setup.census_modal.success_title',
        successLead: 'prospects.profile.activation_setup.census_modal.success_lead',
        successLeadAppOnly: 'prospects.profile.activation_setup.census_modal.success_lead_app_only',
        successEmployees: 'prospects.profile.activation_setup.census_modal.success_employees',
        apply: 'prospects.profile.activation_setup.census_modal.apply',
        applying: 'prospects.profile.activation_setup.census_modal.applying',
        close: 'prospects.profile.activation_setup.census_modal.close',
        cancel: 'prospects.profile.activation_setup.census_modal.cancel',
        keepInBackground: 'prospects.profile.activation_setup.census_modal.keep_in_background',
        tryAgain: 'prospects.profile.activation_setup.census_modal.try_again',
        error: 'prospects.profile.activation_setup.census_modal.error',
        errorSummary: 'prospects.profile.activation_setup.census_modal.error_summary',
        errorManyTitle: 'prospects.profile.activation_setup.census_modal.error_many_title',
        errorManyBannerTitle: 'prospects.profile.activation_setup.census_modal.error_many_banner_title',
        errorManyDesc: 'prospects.profile.activation_setup.census_modal.error_many_desc',
        errorFormatCount: 'prospects.profile.activation_setup.census_modal.error_format_count',
        errorEmptyCellCount: 'prospects.profile.activation_setup.census_modal.error_empty_cell_count',
        downloadErrorReport: 'prospects.profile.activation_setup.census_modal.download_error_report',
        uploadCorrectedFile: 'prospects.profile.activation_setup.census_modal.upload_corrected_file',
        errorMinimumTitle: 'prospects.profile.activation_setup.census_modal.error_minimum_title',
        errorMinimumBannerTitle: 'prospects.profile.activation_setup.census_modal.error_minimum_banner_title',
        errorMinimumBannerTitleAppOnly:
          'prospects.profile.activation_setup.census_modal.error_minimum_banner_title_app_only',
        errorMinimumDesc: 'prospects.profile.activation_setup.census_modal.error_minimum_desc',
        errorMinimumDescAppOnly: 'prospects.profile.activation_setup.census_modal.error_minimum_desc_app_only',
        uploadNewCensus: 'prospects.profile.activation_setup.census_modal.upload_new_census',
        priceMismatchTitle: 'prospects.profile.activation_setup.census_modal.price_mismatch_title',
        priceMismatchLead: 'prospects.profile.activation_setup.census_modal.price_mismatch_lead',
        priceMismatchNew: 'prospects.profile.activation_setup.census_modal.price_mismatch_new',
        priceMismatchOriginal: 'prospects.profile.activation_setup.census_modal.price_mismatch_original',
        priceMismatchPerMonth: 'prospects.profile.activation_setup.census_modal.price_mismatch_per_month',
        priceMismatchReason: 'prospects.profile.activation_setup.census_modal.price_mismatch_reason',
        priceMismatchReasonMore: 'prospects.profile.activation_setup.census_modal.price_mismatch_reason_more',
        priceMismatchReasonFewer: 'prospects.profile.activation_setup.census_modal.price_mismatch_reason_fewer',
        priceMismatchReasonAges: 'prospects.profile.activation_setup.census_modal.price_mismatch_reason_ages',
        acceptNewPrice: 'prospects.profile.activation_setup.census_modal.accept_new_price',
        rejectNewPrice: 'prospects.profile.activation_setup.census_modal.reject_new_price',
        errorServiceTitle: 'prospects.profile.activation_setup.census_modal.error_service_title',
        errorServiceDesc: 'prospects.profile.activation_setup.census_modal.error_service_desc',
        errorServiceNote: 'prospects.profile.activation_setup.census_modal.error_service_note'
      },
      activationModal: {
        title: 'prospects.profile.activation_setup.activation_modal.title',
        titleAppOnly: 'prospects.profile.activation_setup.activation_modal.title_app_only',
        intro: 'prospects.profile.activation_setup.activation_modal.intro',
        introAppOnly: 'prospects.profile.activation_setup.activation_modal.intro_app_only',
        introQuote: 'prospects.profile.activation_setup.activation_modal.intro_quote',
        startDateLabel: 'prospects.profile.activation_setup.activation_modal.start_date_label',
        benefitsNote: 'prospects.profile.activation_setup.activation_modal.benefits_note',
        enrollmentLabel: 'prospects.profile.activation_setup.activation_modal.enrollment_label',
        enrollmentTooltip: 'prospects.profile.activation_setup.activation_modal.enrollment_tooltip',
        summaryTitle: 'prospects.profile.activation_setup.activation_modal.summary_title',
        enrollmentOpens: 'prospects.profile.activation_setup.activation_modal.enrollment_opens',
        enrollmentCloses: 'prospects.profile.activation_setup.activation_modal.enrollment_closes',
        policyEffective: 'prospects.profile.activation_setup.activation_modal.policy_effective',
        cancel: 'prospects.profile.activation_setup.activation_modal.cancel',
        confirm: 'prospects.profile.activation_setup.activation_modal.confirm',
        error: 'prospects.profile.activation_setup.activation_modal.error',
        errorLabel: 'prospects.profile.activation_setup.activation_modal.error_label'
      }
    },
    actions: {
      getQuote: 'prospects.profile.actions.get_quote',
      more: 'prospects.profile.actions.more',
      markLost: 'prospects.profile.actions.mark_lost',
      markInactive: 'prospects.profile.actions.mark_inactive',
      edit: 'prospects.profile.actions.edit',
      add: 'prospects.profile.actions.add',
      save: 'prospects.profile.actions.save'
    },
    form: {
      generalInfo: 'prospects.profile.form.general_info',
      identification: 'prospects.profile.form.identification',
      location: 'prospects.profile.form.location',
      generalContactInfo: 'prospects.profile.form.general_contact_info',
      communication: 'prospects.profile.form.communication',
      billingParty: 'prospects.profile.form.billing_party',
      sameAsPrimary: 'prospects.profile.form.same_as_primary'
    }
  }
};
